// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9f6f154d","977":"03df5f75"}[chunkId] + ".chunk.js";
};